import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { Subscription, filter } from 'rxjs';

import { CapicheLoggerService } from 'capiche-logger';
import { CapicheMixpanelService } from 'capiche-mixpanel';
import { CapicheMaterialModule } from 'capiche-material';

import { LoginData } from '../../interfaces/login-data.interface';
import { AuthService } from '../../services/auth/auth.service';
import { LoginFormComponent } from '../../components/login-form/login-form.component';

@Component({
  selector: 'capiche-auth-register',
  imports: [CommonModule, RouterModule, LoginFormComponent, CapicheMaterialModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.css',
})
export class RegisterComponent implements OnInit, OnDestroy {
  mixpanel: CapicheMixpanelService = inject(CapicheMixpanelService);
  logger = new CapicheLoggerService('register-page.component:', false);

  private authService = inject(AuthService);
  private router = inject(Router);

  // this is a temporary workaround that does not allow to show same hack as for
  // see: https://capiche.atlassian.net/browse/CSW-1046
  // sign-in-with-google-requires-adaption-for-chrome-extension-manifestv3
  showSignInWithGoogle: boolean = this.authService.config.googleSignInHandler ? false : true; // hide signInWithGoogle if extensions for now

  msg: string = '';
  loading: boolean = false;
  private routerSub: Subscription | undefined;

  ngOnInit(): void {
    this.logger.log('ngOnInit');
    this.mixpanel.identify('anonymous');
    this.mixpanel.track('register-page.component: ngOnInit');

    this.routerSub = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.loading = false;
      this.logger.log('navigation end: loading:', this.loading);
    });
  }

  ngOnDestroy(): void {
    this.logger.log('ngOnDestroy');
    this.mixpanel.identify('anonymous');
    this.mixpanel.track('register-page.component: ngOnDestroy');
    this.routerSub?.unsubscribe();
  }

  register(data: LoginData) {
    this.loading = true;
    this.logger.log('register:', data.email, 'loading:', this.loading);
    this.msg = '';
    this.authService
      .register(data)
      .then(() => this.logger.log('register .then'))
      .catch((e) => {
        this.logger.log(e.message);
        switch (e.code) {
          case 'auth/email-already-in-use':
            this.msg =
              'We encountered an issue. ' +
              "If this is your email address click the 'Sign In Here' button to try signing in.";
            break;
          case 'auth/weak-password':
            this.msg = 'Password should be at least 6 characters';
            break;
          case 'auth/invalid-email':
            this.msg = 'Invalid email address';
            break;
          default:
            this.logger.error('error registering:', e);
        }
        this.loading = false; // fallback in case of failure
      });
  }
}
